export const GREETING_MOBILE = 'Welcome to Priceline'
export const GREETING_DESKTOP = 'Welcome to Priceline'

const Content = {
  homepage: {
    hotel: {
      signedInSubHeading: 'You qualify for VIP hotel deals! Search and save.',
      expressDeals: {
        headline: 'Search for Express Deals',
        subHeadline: 'Save up to 60% Fast and Easy - No Bidding Required!'
      }
    },
    flights: {
      expressDeals: {
        headline: 'Search for Express Deals',
        subHeadline: 'Save up to 50% on trusted airlines!'
      }
    },
    vip: {
      defaultHeading: GREETING_MOBILE,
      headlineWithName: '{firstName}, you qualify for VIP deals',
      promo: {
        headline:
          'You qualify for hotel discounts of up to 50% as a VIP member!',
        headlineWithName:
          '{firstName}, you qualify for hotel discounts of up to 50% as a VIP member!'
      }
    }
  }
} as const

export default Content
